export default [
  {
    path: '/pvh/order-type/list',
    name: 'PvhOrderTypeList',
    component: () => import('@/views/Pvh/PvhOrderTypeList.vue')
  },
  {
    path: '/pvh/order-type/update/:id',
    name: 'PvhOrderTypeUpdate',
    component: () => import('@/views/Pvh/PvhOrderTypeUpdate.vue'),
    redirect: {
      name: 'PvhOrderTypeUpdate_order'
    },
    children: [
      {
        path: 'order',
        name: 'PvhOrderTypeUpdate_order',
        component: () => import('@/components/pvh/PvhOrderTypeUpdateOrder')
      },
      {
        path: 'chain',
        name: 'PvhOrderTypeUpdate_chain',
        component: () => import('@/components/pvh/PvhOrderTypeUpdateChain')
      }
    ]
  }
]
